import { ReactNode } from 'react';

type Props = { children: ReactNode };

export const Overlay = ({ children }: Props) => {
  return (
    <div className="fixed z-50 inset-0 grid place-items-center bg-white/70">
      <div className="flex flex-col items-center">{children}</div>
    </div>
  );
};
